import React from "react";

export default function UserIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0002 2C12.2093 2 14.0002 3.79093 14.0002 6C14.0002 8.20907 12.2093 10 10.0002 10C7.79115 10 6.00022 8.20907 6.00022 6C6.00022 3.79093 7.79115 2 10.0002 2ZM16.8397 17.808C16.7207 17.9264 16.5565 18 16.3752 18H3.62528C3.26262 18 2.96875 17.7061 2.96875 17.344C2.96875 15.4021 3.75595 13.6443 5.02848 12.3717C6.30102 11.0997 8.05888 10.3125 10.0002 10.3125C11.9416 10.3125 13.6994 11.0997 14.972 12.3717C16.2445 13.6443 17.0317 15.4021 17.0317 17.344C17.0317 17.5253 16.9581 17.6891 16.8397 17.808Z" fill="#404143"/>
    </svg>

  );
}
